import { Theme } from '@material-ui/core';
const styles = (theme: Theme) =>
  ({
    containerConfirmation: {
      padding: 30,
      textAlign: 'center',
      marginTop: 50,
      '& .title': {
        '& h2': {
          fontWeight: '400',
        },
      },
      '& h5': {
        fontWeight: '400',
        padding: '24px 0',
      },
    },
    illustration: {
      position: 'absolute',
    },
    leftIllustration: {
      left: 0,
      bottom: 10,
      lineHeight: 0,
    },
    rightIllustration: {
      right: 0,
      top: 310,
    },
    title: {
      textAlign: 'center',
      '& > h3': {
        fontFamily: 'Poppins, sans-serif',
      },
    },
    container: {
      maxWidth: '650px',
      margin: 'auto',
      fontSize: 17,
    },
  } as any);

export default styles;
